<main>
  <div>

    <mat-menu #menuAddQuestions="matMenu"  xPosition="before" [hasBackdrop]="false">
      <div mat-menu-item *ngFor="let type of questionTypes" class="menuElement">


        <span>{{type.name | translation}}</span>

        <button class="addQuestionButton"  (click)="sendQuestionType(type.key)" mat-raised-button color="accent"><mat-icon>add</mat-icon></button>
      </div>


    </mat-menu>


      <button class="openQuestionList" [matMenuTriggerFor]="menuAddQuestions" mat-raised-button color="accent">{{'addQuestion' | translation}}</button>
  </div>
</main>
